import { ProductKeys } from '../../constants/product-keys';

/** Maps a code result's `repository.scm` to its product key, for icons and analytics. */
export const scmToProductKey = (scm?: string | null): ProductKeys | undefined => {
	switch (scm) {
		case 'bbc':
		case 'bitbucket':
			return ProductKeys.Bitbucket;
		case 'github':
			return ProductKeys.Github;
		default:
			return undefined;
	}
};
